import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-landing-layout',
  templateUrl: './landing-layout.component.html',
  styleUrls: []
})
export class LandingLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
